import Footer from "@components/Footer";
import Header from "@components/Header";
import ReferralTermAndConditions from "@components/ReferralTermsAndConditions";
import SeoHead from "@components/SeoHead";
import Layout from "@components/StaticPageLayout";
import ZohoChatWidget from "@components/ZohoChatWidget";
import { useSiteConfig } from "@context/siteConfig";
import withSiteConfig, { getSiteConfig } from "@context/withSiteConfig";
import withTranslations, { getTranslations } from "@context/withTranslations";
import { GetServerSideProps, NextPage } from "next";

interface ReferralTermsProps {
  siteConfig: SiteConfig;
  translations: Translations;
}

const ReferralTerms: NextPage<ReferralTermsProps> = () => {
  const { locale, referrals, withdrawalMethods } = useSiteConfig();
  return (
    <>
      <SeoHead page="terms" />
      <Header />
      <ZohoChatWidget />
      <Layout>
        <ReferralTermAndConditions
          locale={locale}
          referrals={referrals}
          withdrawalMethods={withdrawalMethods}
        />
      </Layout>
      <Footer />
    </>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  const env = process.env.APP_ENV;
  const siteConfig = getSiteConfig(context, env);
  const translations = await getTranslations(siteConfig);

  return {
    props: {
      siteConfig,
      translations,
    },
  };
};

export default withTranslations(withSiteConfig(ReferralTerms));
